/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react'
import classNames from 'classnames'


class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props
    return (
      <svg width="14" height="8" viewBox="0 0 14 8" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  
  <polygon points="12.632 .022 14 1.321 7.042 8 0 1.307 1.36 0 7.034 5.394" className="icon-fill"/>
</svg>

    )
  }
}

Icon.displayName = 'DrawerCaretIcon'

export default Icon
